/*
 * Purpose: Fetch public system health from API /health
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { getApiBase } from '@/lib/apiBase';
import type { HealthFetchMeta, SystemHealthSnapshot } from '@/lib/systemHealthTypes';

export async function fetchSystemHealth(): Promise<{
  data: SystemHealthSnapshot;
  meta: HealthFetchMeta;
}> {
  const started = performance.now();
  const base = getApiBase();
  const url = base ? `${base}/health?live=1` : '/health?live=1';

  const res = await fetch(url, {
    method: 'GET',
    credentials: 'omit',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });

  const latencyMs = Math.round(performance.now() - started);

  if (!res.ok) {
    if (res.status === 429) {
      throw new Error('Rate limited — wait a moment and refresh');
    }
    throw new Error(`Health check failed (${res.status})`);
  }

  const data = (await res.json()) as SystemHealthSnapshot;

  return {
    data,
    meta: {
      fetchedAt: new Date().toISOString(),
      latencyMs,
      rateLimitRemaining: res.headers.get('X-RateLimit-Remaining'),
    },
  };
}
